import { useMemo } from 'react';

import { TIMELINE_DISPLAY_TYPE, TRANSCRIPT_DISPLAY_TYPE } from '../Clip/ClipPlayer/ClipTimelineV2/ClipTimelineTypes';
import EventMigrationPopup from '../SessionDetail/EventMigrationPopup';
import ClipPlayerV2 from '@/App/remotion/MainPlayer/ClipPlayerV2';

import ClipPlayerV2WithNewTimeline from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

import { canUseNewTimelineForUnmigratedLiveEvent } from '@/stores/clip';
import { useSubscribeToTranslateNotification } from '@/hooks/useSubscribeToTranslateNotification';
import useSavedSearch from '@/hooks/useSavedSearch';
import { isClipInvalid } from '@/libs/clipUtils';

const RecordingsPageInternal = ({ canShow }: { canShow: boolean }) => {
  const { isSavedSearchPage } = useSavedSearch();

  const { clipData } = useClipsContext();

  useSubscribeToTranslateNotification({ onDone: undefined });

  const isReadOnlyUI = useMemo(() => {
    if (clipData.locked) {
      return true;
    }
    return false;
  }, [clipData.locked]);

  return (
    <div className="flex h-full overflow-hidden">
      <div className="flex grow flex-col overflow-hidden transition-all duration-[400ms] ease-in-out">
        <div className="relative ml-1 flex h-full grow flex-col">
          {canShow && (
            <div className="h-full">
              {isReadOnlyUI ? (
                // Add handling for showLockIconInHeader in ClipPlayerV2WithNewTimeline when removing ClipPlayerV2
                <ClipPlayerV2
                  timelineDisplayType={TIMELINE_DISPLAY_TYPE.PROGRESS_BAR}
                  showClipHeader={true}
                  canEditCaptions={false}
                  showLockIconInHeader={true}
                  isSharedPage
                />
              ) : (
                <ClipPlayerV2WithNewTimeline
                  transcriptDisplayType={TRANSCRIPT_DISPLAY_TYPE.FULL}
                  timelineDisplayType={TIMELINE_DISPLAY_TYPE.SEGMENTS}
                  canEditCaptions
                  showClipHeader
                  canEditSpeakerLabel={true}
                  canEditImages={true}
                  canEditTextElements={true}
                  canEditVideos={true}
                  canEditLottie={true}
                />
              )}
            </div>
          )}
        </div>
      </div>
      {!isClipInvalid(clipData) && canUseNewTimelineForUnmigratedLiveEvent(clipData) && (
        // At Saved search page, Session details doesn't exist hence need to Mount Migration popup here
        <EventMigrationPopup enabled={isSavedSearchPage} content={clipData.content} />
      )}
    </div>
  );
};

export default RecordingsPageInternal;
